const common = {
  'common.loading': 'Cargando...',
  'common.error': 'Ocurrió un error',
  'common.success': '¡Éxito!',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.submit': 'Enviar',
  'common.save': 'Guardar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.add': 'Agregar',
  'common.remove': 'Remover',
  'common.continue': 'Continuar',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.search': 'Buscar',
  'common.filter': 'Filtrar',
  'common.sort': 'Ordenar',
  'common.noResults': 'Página no encontrada',
  'common.selectOne': 'Seleccionar uno',
  'common.required': 'Requerido',
  'common.optional': 'Opcional',
  'common.learnMore': 'Aprende Más',
  'common.getStarted': 'Comenzar',
  'common.signUp': 'Regístrate',
  'common.signIn': 'Iniciar Sesión',
  'common.dark': 'Oscuro',
  'common.light': 'Claro',
  'common.system': 'Sistema',
  'common.followTheme': 'Seguir tema del sistema',
  'common.language': 'Idioma',
  'common.viewMore': 'Ver Más',
  'common.viewLess': 'Ver Menos',
  'common.home': 'Inicio',
  'common.terms': 'Términos de Servicio',
  'common.privacy': 'Política de Privacidad',
  'common.cookies': 'Política de Cookies',
  'common.contact': 'Contáctanos',
  'common.contactMe': 'Contáctame',
  'common.profile': 'Perfil',
  'common.settings': 'Configuraciones',
  'common.account': 'Cuenta',
  'common.dashboard': 'Panel de control',
  'common.theme.light': 'Tema Claro',
  'common.theme.dark': 'Tema Oscuro',
  'Member Since': 'Miembro Desde',
  'profileNotFound': 'Perfil no encontrado',
  'common.documentation': 'Documentación API',
  
  // Navigation items
  'nav.home': 'Inicio',
  'nav.join': 'Únete a The Club',
  'nav.tutorials': 'Tutoriales',
  'nav.strategies': 'Estrategias',
  'nav.radex': 'Radex Markets',
  'nav.news': 'Noticias',
  
  // News translations
  'news.title': 'Últimas Noticias',
  'news.description': 'Mantente actualizado con nuestros últimos artículos y anuncios',
  'news.filterByTag': 'Filtrar por etiqueta',
  'news.allPosts': 'Todas las Publicaciones',
  'news.noPostsFound': 'No se encontraron publicaciones',
  'news.viewAllPosts': 'Ver todas las publicaciones',
  'news.backToNews': 'Volver a Noticias',
  'news.relatedPosts': 'Publicaciones Relacionadas',
  'news.sharePost': 'Compartir esta publicación',
  'news.postNotFound': 'Publicación no encontrada',
  'news.pagination.previous': 'Anterior',
  'news.pagination.next': 'Siguiente',
  
  // Social media links - Spanish specific
  'social.instagram': 'https://www.instagram.com/theclublatinoamerica/',
  'social.tiktok': 'https://www.tiktok.com/@theclublatinoamerica',
  'social.youtube': 'https://www.youtube.com/@TheClubLatinoamerica',
  'social.facebook': 'https://www.facebook.com/theclublatinoamerica/',
  'social.telegram': 'https://t.me/theclublatinoamerica',
  
  // Footer translations
  'footer.company.description': 'The Club ofrece productos y servicios financieros innovadores diseñados para ayudarte a hacer crecer tu riqueza y lograr la libertad financiera.',
  'footer.theclub': 'The Club',
  'footer.conditions': 'Términos y condiciones',
  'footer.customersupport': 'Servicio al Cliente',
  'footer.contactuswhatsapp': 'WhatsApp',
  'footer.radex': 'Radex Markets',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.terms': 'Términos',
  'footer.privacy': 'Privacidad',
  'footer.cookies': 'Cookies',
  'footer.contactUs': 'Contáctanos',
  'footer.contactMe': 'Contáctame',
  
  // Radex Markets translations
  'radex.hero.title': 'The Club y Asociación con Radex Markets',
  'radex.hero.subtitle': 'Descubre oportunidades excepcionales de trading a través de nuestra asociación estratégica',
  'radex.hero.learnMore': 'Saber Más',
  'radex.hero.visitWebsite': 'Visitar Sitio Web',
  'radex.hero.partnership': 'Oportunidades de Inversión Exclusivas',
  'radex.hero.benefit1': 'Broker Licenciado y Regulado',
  'radex.hero.benefit2': 'Tecnología de Trading de Vanguardia',
  'radex.hero.benefit3': 'Protocolos de Seguridad Avanzados',
  'radex.hero.benefit4': 'Beneficios Exclusivos para Miembros de The Club',
  
  'radex.about.title': 'Acerca de Radex Markets',
  'radex.about.subtitle': 'Un broker regulado comprometido con la seguridad, transparencia y tecnología de trading de vanguardia',
  'radex.about.establishmentTitle': 'Presencia Establecida',
  'radex.about.establishmentText': 'RADEX MARKETS fue establecido en 2019 y tiene su sede en la República de Seychelles. Opera bajo el nombre comercial de GO Markets International Ltd, una empresa constituida en la República de Seychelles con número de registro 8425985-1.',
  'radex.about.regulationTitle': 'Licenciado y Regulado',
  'radex.about.regulationText': 'La firma está licenciada y regulada por la Autoridad de Servicios Financieros de Seychelles (FSA) bajo la Licencia de Dealer de Valores Número SD043, asegurando un entorno de trading seguro y conforme.',
  'radex.about.technologyTitle': 'Tecnología Avanzada',
  'radex.about.technologyText': 'Radex Markets ofrece tecnología de vanguardia y un entorno de trading competitivo diseñado para satisfacer las necesidades de los traders modernos, con ejecución confiable y herramientas profesionales.',
  'radex.about.transparencyTitle': 'Transparencia y Confianza',
  'radex.about.transparencyText': 'La transparencia es un valor fundamental en Radex, demostrado a través de una comunicación clara, honesta y multilingüe. Reconocido por su integridad, Radex Markets se destaca como una plataforma segura y confiable para los traders que buscan fiabilidad.',
  
  'radex.features.title': '¿Por qué elegimos Radex Markets?',
  'radex.features.subtitle': 'Experimenta las ventajas de operar con un broker comprometido con la excelencia',
  'radex.features.security': 'Protección del Cliente',
  'radex.features.securityText': 'Robustos protocolos de seguridad para salvaguardar los fondos de los clientes y los datos personales, asegurando un entorno de trading seguro.',
  'radex.features.technology': 'Plataforma de Vanguardia',
  'radex.features.technologyText': 'Tecnología de trading avanzada con ejecución confiable y herramientas profesionales para traders de todos los niveles.',
  'radex.features.transparency': 'Transparencia Total',
  'radex.features.transparencyText': 'Comunicación clara y honesta y ejecución confiable de operaciones, manteniendo los más altos estándares de transparencia.',
  'radex.features.global': 'Acceso Global',
  'radex.features.globalText': 'Soporte y servicios multilingües que atienden a traders de diversas regiones y orígenes.',
  
  'radex.partnership.title': 'The Club y Asociación con Radex Markets',
  'radex.partnership.description': 'Nuestra asociación estratégica con Radex Markets nos permite ofrecer oportunidades de inversión únicas a los miembros de nuestro club, combinando nuestra experiencia con un bróker regulado y confiable.',
  'radex.partnership.details': 'A través de esta colaboración, los miembros de The Club obtienen acceso a condiciones de trading exclusivas, gestión mejorada de cuentas y soporte especializado de ambas organizaciones. La asociación entre Radex Markets y The Club se basa en valores compartidos de transparencia, seguridad y entrega de valor excepcional a nuestra comunidad.',
  'radex.partnership.contactUs': 'Contactar para Detalles',
  'radex.partnership.visitRadex': 'Visitar Radex Markets',
  'radex.partnership.benefitsTitle': 'Beneficios de la Asociación',
  'radex.partnership.benefit1Title': 'Seguridad Mejorada',
  'radex.partnership.benefit1Text': 'Opera con confianza sabiendo que tus fondos están protegidos por los robustos protocolos de seguridad de Radex Markets.',
  'radex.partnership.benefit2Title': 'Productos Exclusivos',
  'radex.partnership.benefit2Text': 'Accede a productos de inversión especializados y condiciones de trading disponibles solo para miembros de The Club.',
  'radex.partnership.benefit3Title': 'Soporte Profesional',
  'radex.partnership.benefit3Text': 'Recibe asistencia dedicada de los equipos de The Club y Radex Markets para una experiencia de trading mejorada.',
  
  // Documentation translations
  'docs.title': 'Documentación API',
  'docs.introduction': 'Introducción',
  'docs.introDescription': 'Esta aplicación utiliza GraphQL como una capa flexible de acceso a datos, impulsada por la extensión pg_graphql en Supabase.',
  'docs.benefits': 'Los beneficios de este enfoque incluyen:',
  'docs.benefitDecoupling': 'Desacoplamiento del frontend del acceso directo a la base de datos',
  'docs.benefitTypeSafety': 'Fuerte seguridad de tipos en toda la aplicación',
  'docs.benefitFlexibility': 'Flexibilidad para cambiar implementaciones de backend con cambios mínimos',
  'docs.architecture': 'Visión General de la Arquitectura',
  'docs.architectureDescription': 'La aplicación utiliza una arquitectura en capas que separa las preocupaciones y proporciona flexibilidad:',
  'docs.serviceLayer': 'Capa de Abstracción de Servicios',
  'docs.serviceLayerDescription': 'La capa de servicio proporciona una interfaz consistente independientemente de la implementación subyacente, permitiendo que la aplicación cambie entre llamadas directas a Supabase y consultas GraphQL sin cambiar el código de la aplicación.',
  'docs.schema': 'Esquema GraphQL',
  'docs.schemaDescription': 'El esquema GraphQL se genera automáticamente a partir de la estructura de la base de datos por pg_graphql, con algunos resolvers personalizados para necesidades específicas:',
  'docs.implementationGuide': 'Guía de Implementación',
  'docs.frontendImplementation': 'Implementación Frontend',
  'docs.frontendImplementationDescription': 'Para interactuar con la API GraphQL desde el frontend, utiliza Apollo Client:',
  'docs.serviceFactory': 'Factoría de Servicios',
  'docs.serviceFactoryDescription': 'El patrón de factoría de servicios permite cambiar fácilmente entre diferentes implementaciones de servicios:',
  'docs.switchingBackends': 'Cambio de Backend',
  'docs.switchingBackendsDescription': 'Para cambiar entre diferentes implementaciones de backend, llama a la función setServiceImplementation:',
  'docs.backendImplementation': 'Implementación Backend',
  'docs.backendImplementationDescription': 'El backend utiliza Supabase con la extensión pg_graphql para proporcionar una API GraphQL:',
  'docs.pgGraphql': 'Extensión pg_graphql',
  'docs.pgGraphqlDescription': 'La extensión pg_graphql genera automáticamente una API GraphQL a partir de tu esquema de base de datos:',
  'docs.alternativeBackends': 'Backends Alternativos',
  'docs.alternativeBackendsDescription': 'Para implementar backends alternativos, crea nuevas implementaciones de servicios que se ajusten a las interfaces de servicio definidas en la factoría de servicios.',

  // Error translations
  'error.defaultTitle': 'Ha ocurrido un error',
  'error.defaultMessage': ' ',
  'error.profileInvalidTitle': 'Ha ocurrido un error',
  'error.profileInvalidMessage': 'El perfil de usuario no es válido', 
  'error.goHome': 'Ir al Inicio',
  'error.contactSupport': 'Contactar Soporte',
};

const calendar = {
  'calendar.january': 'Enero',
  'calendar.february': 'Febrero',
  'calendar.march': 'Marzo',
  'calendar.april': 'Abril',
  'calendar.may': 'Mayo',
  'calendar.june': 'Junio',
  'calendar.july': 'Julio',
  'calendar.august': 'Agosto',
  'calendar.september': 'Septiembre',
  'calendar.october': 'Octubre',
  'calendar.november': 'Noviembre',
  'calendar.december': 'Diciembre',
  'calendar.months.january': 'Ene',
  'calendar.months.february': 'Feb',
  'calendar.months.march': 'Mar',
  'calendar.months.april': 'Abr',
  'calendar.months.may': 'May',
  'calendar.months.june': 'Jun',
  'calendar.months.july': 'Jul',
  'calendar.months.august': 'Ago',
  'calendar.months.september': 'Sep',
  'calendar.months.october': 'Oct',
  'calendar.months.november': 'Nov',
  'calendar.months.december': 'Dic',
  'calendar.weekdays.monday': 'Lu',
  'calendar.weekdays.tuesday': 'Ma',
  'calendar.weekdays.wednesday': 'Mi',
  'calendar.weekdays.thursday': 'Ju',
  'calendar.weekdays.friday': 'Vi',
  'calendar.weekdays.saturday': 'Sa',
  'calendar.weekdays.sunday': 'Do',
};

export default {
  ...common,
  ...calendar,
};
